/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * A form in the /forms list.
 */
export type FormSummary = {
  id: number;
  name: string;
  audience: FormSummary.audience;
  modified_at: string;
  filled_count: number;
  waiting_count: number;
  public_id?: string | null;
};

export namespace FormSummary {
  export enum audience {
    FAMILIES = "families",
    TUTORS = "tutors",
    INQUIRY = "inquiry",
  }
}
